import {ContactI18n} from '@/locales/base.message.locales';

export const contact: ContactI18n = {
  text: 'Soon we will return your contact by email.',
  title: 'Your message has</br>been successfully sent',
  us: {
    title: 'Contact Us',
    text: ' To connect with the Global Social League is fast.<br/>Just fill in the fields below and we will send you any information you wish.',
  },
  email: {
    failed: 'Sorry, an error occurred while sending the contact email, please try again!',
    success: 'Thanks! Contact e-mail sent successfully, please wait for response.'
  }
};
